import { render } from "./HistoryMessageContent.vue?vue&type=template&id=4d41e2ff&scoped=true"
import script from "./HistoryMessageContent.vue?vue&type=script&lang=js"
export * from "./HistoryMessageContent.vue?vue&type=script&lang=js"

import "./HistoryMessageContent.vue?vue&type=style&index=0&id=4d41e2ff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d41e2ff"]])

export default __exports__